import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column, Row } from "simple-flexbox";
import Button from "@material-ui/core/Button";
import { StyleSheet, css } from "aphrodite";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
    detailSip,
    changeSipType,
} from "../../actions/p2kb/sip_action";
import {
    getSipPending,
    getSipError,
    getChangeSipType,
} from "../../reducers/p2kb/sip_reducer";
import { reduxForm, Field } from "redux-form";
import { renderInput, renderInputAktivasi } from "../../components/form/FormComponent";

const styles = StyleSheet.create({
    approveButton: {
        background: "#2CB96A 0% 0% no-repeat padding-box",
        boxShadow: "none",
    },
    rejectButton: {
        background: "#EAEBED 0% 0% no-repeat padding-box",
        marginRight: 10,
        color: "#495057",
        boxShadow: "none",
    },
    footerModal: {
        marginTop: 20,
        backgroundColor: "#FBFBFD",
        height: 80,
        paddingLeft: 40,
        paddingRight: 40,
    },
    bodyModal: {
        paddingLeft: 40,
        paddingRight: 40,
    }
});

class SipModalDeactivation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notes_value: null,
        }
        this.handleSipDeactivation = this.handleSipDeactivation.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        if (event !== undefined) {
            const value = event.target.value
            this.setState({ notes_value: value })
        }
    }

    handleSipDeactivation(event) {
        event.preventDefault();
        const { id, changeSipType, detailSip } = this.props;
        const onHide = this.props.onHide();
        let param_changeSipType = {
            id: id,
            sip_type: 0,
            deactivation_notes: this.state.notes_value,
        }
        const callback = () => {
            onHide();
            detailSip(id);
        }
        changeSipType(param_changeSipType, callback);
    }

    render() {
        const { changeSipType_pending, memberName } = this.props;
        return (
            <div>
                <Modal
                    show={this.props.show}
                    onHide={this.props.onHide()}
                    dialogClassName="modal-width"
                    aria-labelledby="contained-modal-title-vcenter"
                >
                    <Modal.Header closeButton>
                        <p style={{ fontSize: 20, fontWeight: 600 }}>Konfirmasi</p>
                    </Modal.Header>
                    <Modal.Body>
                        <form
                            onSubmit={this.handleSipDeactivation}
                            style={{ width: "100%" }}
                        >
                            <Column className={css(styles.bodyModal)}>
                                <span>Apakah Anda yakin ingin mengubah status SIP {memberName} menjadi Nonaktif? </span>
                                <>
                                    <Field
                                        name="deactivation_notes"
                                        placeholder="Masukkan catatan nonaktif SIP"
                                        onChange={this.handleInputChange}
                                        component={renderInputAktivasi}
                                    />
                                </>
                            </Column>
                            <Row
                                horizontal="flex-end"
                                vertical="center"
                                className={css(styles.footerModal)}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={css(styles.rejectButton)}
                                    onClick={this.props.onHide()}
                                >
                                    Batal
                            </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={css(styles.approveButton)}
                                    disabled={changeSipType_pending}
                                >
                                    Ya, Yakin
                            </Button>
                            </Row>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

function validate(values) {
    const { deactivation_notes } = values;
    const errors = {};
    if (!deactivation_notes) {
        errors.deactivation_notes = "Catatan wajib diisi";
    }
    return errors;
}

SipModalDeactivation = reduxForm({
    form: "SipModalDeactivation",
    validate: validate,
    enableReinitialize: true,
    shouldError: () => true
})(SipModalDeactivation);

function mapStateToProps(state) {
    return {
        changeSipType_pending: getSipPending(state.changeSipType),
        changeSipType_data: getChangeSipType(state.changeSipType),
        changeSipType_error: getSipError(state.changeSipType),
    };
}

export default connect(mapStateToProps, { changeSipType, detailSip })(withRouter(SipModalDeactivation));
